import React from 'react'
import { Card } from 'react-bootstrap'

const DigitalTwinBanner = () => {
  return (
    <>
        <Card className="digital-twin-banner no-border rounded-0">
            <Card.Img src={"/assets/digital-twin/images/banner.jpg"} alt="Card image" className="banner-image rounded-0"  />
        </Card>
        <Card className="no-border rounded-0 text-center container">
            <Card.Title className='digital-twin-title'> デジタルツイン </Card.Title>
            <Card.Subtitle className='digital-twin-subtitle'> 環境に生命を吹き込む </Card.Subtitle>
            <Card.Text className='digital-twin-text text-left'>
            オブジェクト、人、場所をメタバースに取り込むための最初のステップは、バーチャルワールドとして再現したい現実世界の "デジタルツイン"を作成することです。このデジタルツインズで再現した空間は、バーチャルな会議室としてだけでなく、人と現実の世界をつなぐ没入型のインターフェイスとして利用することができます。 デジタルツインは、グラフィック、センサー、データなどを使って、企業の機械、システム、設備、資産をデジタル空間で視覚的に表現するものです。これを活用することで、従業員は、バーチャルな工場や倉庫でトレーニングを行うことが可能になります。企業や教育機関のキャンパスや、遠隔地のエンターテインメント・イベント会場としても活用できます。 また、バーチャルな映画制作のセットとして、現場での撮影の代わりに利用することができます。 デジタルツインは、あらゆるバーチャルワールドやアプリケーションのベースとなるものです。大規模なデジタルツインは、何百、何千もの個別の3Dモデルで構成され、オフィス、キャンパス、産業施設、あるいは都市を表現するために組み合わせることができます。私たちは、既存のCAD図面、LIDAR点群、写真測量スキャンを使用してデジタルツイン用の3Dモデルを構築することができます。必要に応じて、完全にゼロから参考写真や専門アーティストによるクリエイティブデザインを基に手作業でモデル化することも可能です。
            </Card.Text>
        </Card>
      
    </>
  )
}

export default DigitalTwinBanner
